import React, { Component } from "react";
import AdminPortListItem from './AdminPortListItem.js';

class AdminPortList extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }

    }
    componentDidMount() {
        this.setState({
            ports: this.props.ports
        });
    }
    componentDidUpdate(oldProps) {
        if (oldProps.ports !== this.props.ports) {
            this.setState({
                ports: this.props.ports
            });
        }
    }
    render() {
        if (!this.state.ports) return (<>No ports</>)

        const ports = structuredClone(this.state.ports);
        let portList = [];
        for (let port of ports) {
            if ((this.props.selectedPort && port._id == this.props.selectedPort) || (!this.props.selectedPort)) {
                portList.push(
                    <AdminPortListItem port={port} key={port._id} getPortData={this.props.getPortData} />
                )
            }
        }

        return (
            <ul className="AdminUserList">
                <AdminPortListItem getPortData={this.props.getPortData} key='createNewPort' />
                {portList}
            </ul>
        );
    }

}



export default AdminPortList;
